import { NavLink } from "react-router-dom";
import {
  LayoutDashboard, FileQuestion, Upload, Users, School, BarChart3, Settings, Flame, LogOut, Calendar,
} from "lucide-react";
import clsx from "@/lib/clsx";

interface Props { onSignOut: () => void; userEmail: string | null; }

const items = [
  { to: "/admin/dashboard", icon: LayoutDashboard, label: "Dashboard" },
  { to: "/admin/questions",  icon: FileQuestion,    label: "Questions" },
  { to: "/admin/upload",     icon: Upload,          label: "Upload" },
  { to: "/admin/students",   icon: Users,           label: "Students" },
  { to: "/admin/schools",    icon: School,          label: "Schools" },
  { to: "/admin/events",     icon: Calendar,        label: "Events" },
  { to: "/admin/analytics",  icon: BarChart3,       label: "Analytics" },
  { to: "/admin/settings",   icon: Settings,        label: "Settings" },
];

export default function AdminSidebar({ onSignOut, userEmail }: Props) {
  return (
    <aside className="w-60 shrink-0 bg-steel-900 border-r border-steel-800 flex flex-col">
      <div className="p-5">
        <div className="flex items-center gap-2 text-white font-display text-lg">
          <Flame className="w-5 h-5 text-forge-400" /> WeldQuest
        </div>
        <div className="text-xs text-steel-400 mt-0.5">Manager dashboard</div>
      </div>
      <nav className="flex-1 px-3 space-y-1">
        {items.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) => clsx(
              "flex items-center gap-2 px-3 py-2 rounded-lg text-sm",
              isActive ? "bg-forge-500/15 text-forge-200 border border-forge-500/30" : "text-steel-300 hover:bg-steel-800 hover:text-white"
            )}
          >
            <Icon className="w-4 h-4" /> {label}
          </NavLink>
        ))}
      </nav>
      <div className="p-3 border-t border-steel-800">
        <div className="text-xs text-steel-400 truncate">{userEmail ?? "—"}</div>
        <button onClick={onSignOut} className="mt-2 btn-outline w-full justify-start text-sm">
          <LogOut className="w-4 h-4" /> Sign out
        </button>
      </div>
    </aside>
  );
}
